import { css } from 'styled-components';
import token from 'styled-token';
import { StyledLabeledControl } from '../../components/LabeledControl/LabeledControl.styles';

/** @class SwitchGroupMixin */
/** @method */
export var SwitchGroupMixin = token({
  borderColor: 'SwitchGroup.borderColor',
  borderWidth: 'SwitchGroup.borderWidth'
}, function (_ref) {
  var borderColor = _ref.borderColor,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth;
  return css(["> ", "{border-top:", "px solid ", ";&:last-child{border-bottom:", "px solid ", ";}}"], StyledLabeledControl, borderWidth, borderColor, borderWidth, borderColor);
});